module.exports = __webpack_public_path__ + "static/media/trash.c509af30.svg";